var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"0"}},[_c('div',{staticClass:"bubble-wrap",class:['bub-' + _vm.type]},[_c('div',{staticClass:"bub-content"},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"bub-arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }